import React, { useState } from 'react';
import { FaVideo, FaPlayCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useAuthToken } from '../contexts/AuthTokenContext';
import "./Home.css"
import "./Home2.css"

const Home = () => {
  const navigate = useNavigate();
  const { token } = useAuthToken();
  
  return (
    <>
    <div className="homepage-container">
      <h1>Welcome to Castly!</h1>
      <p>Pick your adventure and jump right in!</p>
      <div className="options-container">
        <div className="option">
          <img
            src="/watch.jpg"
            alt="Watch"
            className="option-image"
            loading="lazy"
          />
          <button className="option-button" onClick={() => navigate("/view")}>
          <FaPlayCircle className="option-icon" />
          <span className="option-text">Watch</span>
        </button>

        {!token && (
          <>
            <br/>
            <Link to="/login" className="authLink">Login</Link>
            <Link to="/register" className="authLink">Need an account? Register</Link>
          </>
        )}

        </div>
        {/* <div className="option">
          <img
            src="/broadcast.jpg"
            alt="Broadcast"
            className="option-image"
            loading="lazy"
          />
          <button className="option-button" onClick={() => navigate("/broadcast")}>
            <FaVideo className="option-icon" />
            <span className="option-text">Broadcast</span>
          </button>
        </div> */}
        
      </div>
    </div>
    </>
  );
};

export default Home;